module.exports = __webpack_public_path__ + "img/title2.6190a6c9.png";